import type { Order } from '../../features/orders/types/orders.types'

interface StatusBadgeProps {
  status: Order['status']
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const getDisplayStatus = (status: Order['status']) => {
    switch (status) {
      case 'ORDER_RECEIVED':
        return 'Received'
      case 'ORDER_CONFIRMED':
        return 'Confirmed'
      case 'PROCESSING':
        return 'Processing'
      case 'EN_ROUTE':
        return 'En Route'
      case 'DELIVERED':
        return 'Delivered'
      case 'REFUNDED':
        return 'Refunded'
      case 'TRANSFER_FAILED':
        return 'Failed'
      case 'CANCELLED':
        return 'Cancelled'
      case 'RETURNED':
        return 'Returned'
      default:
        return 'Processing'
    }
  }

  const getStatusStyles = () => {
    switch (status) {
      case 'PROCESSING':
        return { backgroundColor: '#E2DEF7' }
      case 'ORDER_CONFIRMED':
        return { backgroundColor: '#E2DEF7' }
      case 'EN_ROUTE':
        return { backgroundColor: '#FEFECD' }
      case 'DELIVERED':
        return { backgroundColor: '#E1FEE3' }
      case 'CANCELLED':
        return { backgroundColor: '#FECDCD' }
      case 'REFUNDED': 
        return { backgroundColor: '#FECDCD' }
      case 'TRANSFER_FAILED':
        return { backgroundColor: '#FECDCD' }
      case 'RETURNED':
        return { backgroundColor: '#FEE4CD' }
      default:
        return { backgroundColor: '#E2DEF7' }
    }
  }

  return (
    <div 
      className="w-fit h-[32px] rounded-[10px] px-[10px] py-[6px] flex items-center justify-center"
      style={getStatusStyles()}
    >
      <span 
        className="font-semibold text-[14px] text-foreground"
        style={{
          lineHeight: '140%',
          letterSpacing: '0%'
        }}
      >
        {getDisplayStatus(status)}
      </span>
    </div>
  )
}